import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="organization-form"
export default class extends Controller {
  static targets = ["vendorFields", "mnoFields", "vpnFields"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const organizationType = this.getOrganizationType()
    
    // Show/hide vendor fields
    if (this.hasVendorFieldsTarget) {
      if (organizationType === "vendor") {
        this.vendorFieldsTarget.style.display = "block"
      } else {
        this.vendorFieldsTarget.style.display = "none"
      }
    }
    
    // Show/hide MNO fields
    if (this.hasMnoFieldsTarget) {
      if (organizationType === "mno") {
        this.mnoFieldsTarget.style.display = "block"
      } else {
        this.mnoFieldsTarget.style.display = "none"
      }
    }
    
    // Show/hide VPN fields (for MNO and law enforcement)
    if (this.hasVpnFieldsTarget) {
      if (organizationType === "mno" || organizationType === "law_enforcement") {
        this.vpnFieldsTarget.style.display = "block"
      } else {
        this.vpnFieldsTarget.style.display = "none"
      }
    }
  }

  getOrganizationType() {
    const select = this.element.querySelector('select[name*="organization_type"]')
    return select ? select.value : ""
  }
}